var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import inputDateReducer, { DATE_NOT_VALID_FORMAT, } from './inputDateReducer';
var datePickerStateReducer = function (state, action) {
    var dateState;
    // set state defaults for most actions
    var baseState = __assign(__assign({}, state), { init: false });
    var type = action.type, actionWithoutType = __rest(action, ["type"]);
    var inputChangeValue = typeof actionWithoutType.value === 'string' ? actionWithoutType.value : '';
    switch (type) {
        case 'newDateValue':
            dateState = inputDateReducer(baseState.date, {
                value: actionWithoutType.value,
                type: 'update',
                options: {
                    format: actionWithoutType.inputFormat,
                },
            });
            return __assign(__assign({}, baseState), { init: true, date: dateState, month: dateState, input: __assign(__assign({}, baseState.input), { value: dateState.inputValue, focused: false, error: !dateState.valid }), calendar: {
                    open: false,
                } });
        case 'dateSelected':
            dateState = inputDateReducer(baseState.date, {
                value: actionWithoutType.value,
                type: 'update',
                options: {
                    format: actionWithoutType.inputFormat,
                },
            });
            return __assign(__assign({}, baseState), { date: dateState, month: dateState, input: __assign(__assign({}, baseState.input), { value: dateState.inputValue, focused: false, error: !dateState.valid }), calendar: {
                    open: false,
                } });
        case 'monthChange':
            dateState = inputDateReducer(baseState.month, {
                value: actionWithoutType.value,
                type: 'update',
                options: {
                    format: actionWithoutType.inputFormat,
                },
            });
            return __assign(__assign({}, baseState), { month: dateState });
        case 'inputChange':
            return __assign(__assign({}, baseState), { input: __assign(__assign({}, baseState.input), { focused: true, value: inputChangeValue }) });
        case 'toggleCalendar':
            return __assign(__assign({}, baseState), { calendar: {
                    open: actionWithoutType.open || !baseState.calendar.open,
                } });
        case 'inputBlur':
            dateState = inputDateReducer(baseState.date, {
                value: baseState.input.value,
                type: 'update',
                options: {
                    format: actionWithoutType.inputFormat,
                },
            });
            return __assign(__assign({}, baseState), { date: dateState, input: __assign(__assign({}, baseState.input), { focused: false, error: !dateState.valid }), calendar: {
                    open: false,
                } });
        default:
            throw new Error('datePickerStateReducer default');
    }
};
var initState = function (props) {
    var initialDate = inputDateReducer({
        inputValue: '',
        value: '',
        date: new Date(),
        valid: true,
    }, {
        value: props.value,
        type: 'init',
        options: {
            format: props.inputFormat,
        },
    });
    return {
        init: true,
        date: initialDate,
        month: Object.create(initialDate),
        input: {
            label: !props.label ? '' : props.label,
            error: !!props.error,
            value: initialDate.inputValue,
        },
        calendar: {
            open: !!props.open,
        },
    };
};
var useDatePicker = function (props) {
    var anchorElRef = React.useRef(null);
    var _a = React.useReducer(datePickerStateReducer, props, initState), datePickerState = _a[0], dispatch = _a[1];
    var onChange = props.onChange, onError = props.onError;
    React.useEffect(function () {
        if (
        // don't call on change when its the initial value
        !datePickerState.init &&
            !datePickerState.input.focused &&
            datePickerState.date.valid &&
            onChange) {
            onChange(datePickerState.date.value, datePickerState.date.inputValue);
        }
    }, [datePickerState.date.inputValue]);
    React.useEffect(function () {
        if (!datePickerState.input.focused &&
            !datePickerState.date.valid &&
            onError) {
            onError(DATE_NOT_VALID_FORMAT, datePickerState.date.inputValue);
        }
    }, [datePickerState.input.error, datePickerState.date.inputValue]);
    React.useEffect(function () {
        dispatch({
            type: 'newDateValue',
            value: props.value,
            inputFormat: props.inputFormat,
        });
    }, [props.value]);
    var inputOnChange = React.useCallback(function (inputValue) {
        dispatch({
            type: 'inputChange',
            value: inputValue,
            inputFormat: props.inputFormat,
        });
    }, [props.inputFormat]);
    var inputOnBlur = React.useCallback(function () {
        dispatch({ type: 'inputBlur', inputFormat: props.inputFormat });
    }, [props.inputFormat, datePickerState.input.value]);
    var calendarOnChange = React.useCallback(function (date) {
        dispatch({
            type: 'dateSelected',
            value: date,
            inputFormat: props.inputFormat,
        });
    }, [props.inputFormat]);
    var calendarMonthChange = React.useCallback(function (date) {
        dispatch({
            type: 'monthChange',
            value: date,
            inputFormat: props.inputFormat,
        });
    }, [props.inputFormat]);
    var toggleOpen = React.useCallback(function (open) {
        dispatch({
            type: 'toggleCalendar',
            open: open,
            inputFormat: props.inputFormat,
        });
    }, [props.inputFormat]);
    return __assign(__assign({}, datePickerState), { input: __assign(__assign({}, datePickerState.input), { onChange: inputOnChange, onBlur: inputOnBlur }), calendar: __assign(__assign({}, datePickerState.calendar), { anchorElRef: anchorElRef,
            getAnchorElm: function () {
                return anchorElRef.current;
            }, onMonthChange: calendarMonthChange, onChange: calendarOnChange, toggle: toggleOpen }) });
};
export default useDatePicker;
